import AutoProcess from './Component';

export default AutoProcess;